import React from 'react';
import { connect } from 'react-redux';
import { useLocale } from 'locale';
import { State } from 'store/state';
import { PricesWrapper, PriceHistoryHeading, PricesBorder } from './styled';
import PriceEstimation from './estimation';
import Listings from './listings';
import { hasEstimationDataSelector } from './selectors';


interface SectionContentILProps {
  hasEstimationData: boolean;
}

const SectionContentIL: React.FC<SectionContentILProps> = props => {
  const { hasEstimationData } = props;
  const { t } = useLocale();

  return (
    <PricesWrapper>
      <PricesBorder>
        {!hasEstimationData ? (
          <PriceHistoryHeading weight="bold">{t('widget.prices.priceHistoryHeading')}</PriceHistoryHeading>
        ) : null}
        <PriceEstimation />
        <Listings />
      </PricesBorder>
    </PricesWrapper>
  );
};

const mapStateToProps = (state: State) => ({
  hasEstimationData: hasEstimationDataSelector(state),
});

export default connect(mapStateToProps)(SectionContentIL);
